import { React, useState, useEffect, useContext } from "react";
import "../Styles/Navbar.css";
import "../Styles/Whatsapp.css";
import { Link, useLocation } from "react-router-dom";
import { BsHandbag, BsSearch } from "react-icons/bs";
import Cart from "./Cart";
import { CartState } from "../Context/Context";
import Sidebar from "./Sidebar";

import { BiMenu } from "react-icons/bi";
import ProductItems from "./ProductItems";
import ProductContext from "../Context/productContext";

export default function Navbar(props) {
  const [showSearch, setshowSearch] = useState(false);
  const searchBar = () => {
    setshowSearch(!showSearch);
    setSearchTerm("");
  };

  const [showCart, setshowCart] = useState(false);
  const cartBar = () => setshowCart(!showCart);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [showMenu, setShowMenu] = useState(false);

  const {
    state: { cart },
    productDispatch,
  } = CartState();
  const context = useContext(ProductContext);
  const { products,fetchProduct } = context;


  useEffect(() => {
    fetchProduct()
  }, [])
  


  const getSearhTerm = (search) => {
    setSearchTerm(search.target.value);
    if (searchTerm !== "") {
      const sortedProducts = products.filter((product) => {
        return Object.values(product)
          .join(" ")
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      });
      setSearchResults(sortedProducts);
    } else {
      const sortedProducts = "No Match Found";
      return sortedProducts;
    }
  };

  let location = useLocation();
  useEffect(() => {}, [location]);

  return (
    <div style={{ display: location.pathname === "/admin"||location.pathname==="/checkout" ? "none" : "block" }}>
      <header>
        <div className="whatsapp-container">
          <a
            target="blank"
            href="https://api.whatsapp.com/send?phone=+919820043813&text=Hi, I want to place my order at Dokmen"
          >
            <img
              src="https://img.icons8.com/color/50/000000/whatsapp.png"
              alt="whatsapp"
              className="w-img"
            />
            <span className="w-text">
              Place Order on Whatsapp +91 9820043813
            </span>
          </a>
        </div>

        <div className="navbar">
          <label className="toggle-btn" htmlFor="togglerTrigger">
            <BiMenu
              id="toggler"
              onClick={() => {
                setShowMenu(!showMenu);
              }}
            ></BiMenu>
          </label>

          <div className="nav-menu left" id="navMenuLeft">
            <ul>
              <li>
                <Link to="#">THE BRAND</Link>
                <ul>
                  <li>
                    <Link to="/journey">JOURNEY</Link>
                  </li>
                  <li>
                    <Link
                      to="/"
                      onClick={() => {
                        props.click();
                      }}
                    >
                      WHY DOKMEN
                    </Link>
                  </li>
                  <li>
                    <Link to="#" onClick={props.showAlert}>
                      BLOG
                    </Link>
                  </li>
                  <li>
                    <Link to="/affiliate">BECOME AN AFFILIATE</Link>
                  </li>
                  <li>
                    <Link to="/affiliate">CORPORATE GIFTING</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="#">SHOP</Link>
                <ul>
                  <li>
                    <Link
                      to="/products"
                      onClick={() => {
                        productDispatch({
                          type: "FILTER_BY_CATEGORY",
                          payload: "all",
                        });
                      }}
                    >
                      ALL
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products"
                      onClick={() => {
                        productDispatch({
                          type: "FILTER_BY_CATEGORY",
                          payload: "men",
                        });
                      }}
                    >
                      MEN
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/products"
                      onClick={() => {
                        productDispatch({
                          type: "FILTER_BY_CATEGORY",
                          payload: "women",
                        });
                      }}
                    >
                      WOMEN
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="#" onClick={props.showAlert}>
                  COMBOS
                </Link>
              </li>
              <li>
                <Link to="#" onClick={props.showAlert}>
                  SALE
                </Link>
              </li>

              <li>
                <Link to="#">HELP</Link>
                <ul>
                  <li>
                    <a
                      href="https://api.whatsapp.com/send?phone=+919820043813&text=I want to ask about Return and Exchange"
                      rel="noreferrer"
                      target="_blank"
                    >
                      RETURNS / EXCHANGE
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://api.whatsapp.com/send?phone=+919820043813&text=I want to track my order"
                      rel="noreferrer"
                      target="_blank"
                    >
                      TRACK YOUR ORDER
                    </a>
                  </li>
                  <li>
                    <Link to="/returnpolicy">RETURN POLICY</Link>
                  </li>
                  <li>
                    <Link to="#" onClick={props.showAlert}>
                      CARE YOUR PRODUCT
                    </Link>
                  </li>
                  <li>
                    <Link to="/affiliate">#ASK DOKMEN</Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="logo">
            <Link to="/">
              <img src="Images/Logo.png" alt="logo" />
              <br />
              <span className="logo-text">
                A BRAND BY <span className="empire-text">EMPIRE</span> FOOTWEAR
              </span>
            </Link>
          </div>

          <nav className="nav-menu right">
            <ul>
              {/* <li>
                <div className="button">
                  <button
                    type="button"
                    className="login-btn"
                    data-bs-toggle="modal" data-bs-target="#loginModal"

                  >
                    Log In
                  </button>
                </div>
              </li> */}
              <li>
                <button onClick={searchBar}>
                  <BsSearch className="menu-items-img" />
                  <span className="icon-title">SEARCH</span>
                </button>
              </li>
              <li>
                <button onClick={cartBar}>
                  <BsHandbag className="menu-items-img" alt="bag" id="bag" />
                  <span className="icon-title">BAG</span>
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                    style={{ backgroundColor: "black" }}
                  >
                    {cart.length}
                  </span>
                </button>
              </li>
            </ul>
          </nav>
        </div>

        <div
          className="search"
          style={{
            transform: showSearch ? "translateY(0)" : "translateY(-120%)",
          }}
        >
          <form action="" className="search-form">
            <input
              type="text"
              name="search"
              value={searchTerm}
              id="search"
              placeholder="Search..."
              onChange={getSearhTerm}
            />
          </form>
        </div>

        <div
          className="search-container"
          style={{ display: searchTerm ? "block" : "none" }}
        >
          <div className="search-items">
            {searchResults.length > 0
              ? searchResults.map((item) => {
                  return (
                    <ProductItems
                    item={item}
                      key={item.id}
                      title={item.title}
                      image={item.image}
                      price={item.price}
                      specialprice={item.specialprice}
                    />
                  );
                })
              : "No Match Found"}
          </div>
        </div>
      </header>
      <Sidebar
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        click={props.click}
        showAlert={props.showAlert}
      />
      <Cart setshowCart={setshowCart} showCart={showCart} />
    </div>
  );
}
